import React, { useState } from 'react';
import '../../styles/library/main.css';

const Main = () => {

    const [activeTab, setActiveTab] = useState('signup_form');

    const handleTabClick = (tabId) => {
        setActiveTab(tabId);
    };

    return (
        <div id='libraryMain'>
            <div className="library-main">
                <div className="container mt-5">
                    <div className="row">
                        <div className="col-md-12">
                            <div>
                                <h1 className="my-heading">Central Library</h1>
                                <p>
                                    <em>RAJA MAHENDRA PRATAP LIBRARY</em>
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <div className="limg">
                                <img className='w-100' src="https://cdn.ccsuniversity.ac.in/public/webp/2026/07/ccsu%20central%20library.webp" 
                                alt="ccsu-library"
                                style={{
                                    height: "650px", 
                                    objectFit: "fill"
                                }}
                                 />
                            </div>
                        </div>
                        <div className="col-md-12 mt-4">
                            <div className="linfo">
                                <p>
                                    Ch. Charan Singh University (Formerly Meerut University) Library was
                                    established in 1968 to serve the academic community of the
                                    university in particular and this region of the state in general.
                                    With the introduction of teaching of M.Phil. And research programmes
                                    in 1969, the library was temporarily moved in L.L.R.M Medical
                                    College Campus. A few buildings were built in 1970 at the university
                                    campus and the library was housed in room No. 106 on the ground
                                    floor of the Institute of Advanced Studies. The designing of the
                                    library building was planned in consultation with the renowned
                                    architect and library experts. Construction of the library was
                                    started in 1970 and it was formally declared open by the first
                                    Chancellor, Dr Gopal Reddy on 11th January1972. The shoebox type
                                    library building is designed on modular pattern. Its countless
                                    louvers, gentle ramps and full-length glass panels on all sides add
                                    to its beauty. It provides 2655.38 sq. meters of floor area spread
                                    over four floors. The Library is now known as Raja Mahendra Pratap
                                    Library.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                {/* tabs */}
                <div className="container mt-3 mb-5">
                    <div className="row rounded-1">
                        {/* <div className="col-md-8 offset-md-2 mt-5 fancy-forms"> */}
                        {/* <div className="cardbox"> */}
                        <ul className="nav nav-tabs  mt-3" id="myTab" role="tablist">
                            <li className="nav-item">
                                <button className={`nav-link ${activeTab === 'signup_form' ? 'active' : ''}`}
                                    onClick={() => handleTabClick('signup_form')}
                                >
                                    Mission of the Library
                                </button>
                            </li>
                            <li className="nav-item">
                                <button
                                    className={`nav-link ${activeTab === 'signup_form1' ? 'active' : ''}`}
                                    onClick={() => handleTabClick('signup_form1')}
                                >
                                    Membership
                                </button>
                            </li>
                            <li className="nav-item">
                                <button
                                    className={`nav-link ${activeTab === 'signup_form2' ? 'active' : ''}`}
                                    onClick={() => handleTabClick('signup_form2')}
                                >
                                    Collection
                                </button>
                            </li>
                            <li className="nav-item">
                                <button
                                 className={`nav-link ${activeTab === 'signup_form3' ? 'active' : ''}`}
                                 onClick={() => handleTabClick('signup_form3')}
                                >
                                    Periodicals
                                </button>
                            </li>
                            <li className="nav-item">
                                <button
                                 className={`nav-link ${activeTab === 'signup_form4' ? 'active' : ''}`}
                                 onClick={() => handleTabClick('signup_form4')}
                                >
                                    Reprography Service
                                </button>
                            </li>
                            <li className="nav-item">
                                <button
                                 className={`nav-link ${activeTab === 'signup_form5' ? 'active' : ''}`}
                                 onClick={() => handleTabClick('signup_form5')}
                                >
                                    Services
                                </button>
                            </li>
                            <li className="nav-item">
                                <button
                                 className={`nav-link ${activeTab === 'signup_form6' ? 'active' : ''}`}
                                 onClick={() => handleTabClick('signup_form6')}
                                >
                                    Institutional Membership
                                </button>
                            </li>
                            <li className="nav-item">
                                <button
                                 className={`nav-link ${activeTab === 'signup_form7' ? 'active' : ''}`}
                                 onClick={() => handleTabClick('signup_form7')}
                                >
                                    Equipments
                                </button>
                            </li>
                            <li className="nav-item">
                                <button
                                 className={`nav-link ${activeTab === 'signup_form8' ? 'active' : ''}`}
                                 onClick={() => handleTabClick('signup_form8')}
                                >
                                    Finance
                                </button>
                            </li>
                            <li className="nav-item">
                                <button
                                 className={`nav-link ${activeTab === 'signup_form9' ? 'active' : ''}`}
                                 onClick={() => handleTabClick('signup_form9')}
                                >
                                    Staff
                                </button>
                            </li>
                            <li className="nav-item">
                                <button
                                 className={`nav-link ${activeTab === 'signup_form10' ? 'active' : ''}`}
                                 onClick={() => handleTabClick('signup_form10')}
                                >
                                    Plagiarism Policy
                                </button>
                            </li>
                            <li className="nav-item">
                                <button
                                 className={`nav-link ${activeTab === 'signup_form11' ? 'active' : ''}`}
                                 onClick={() => handleTabClick('signup_form11')}
                                >
                                    Library Policy &amp; Rules
                                </button>
                            </li>
                            <li className="nav-item">
                                <button
                                 className={`nav-link ${activeTab === 'signup_form12' ? 'active' : ''}`}
                                 onClick={() => handleTabClick('signup_form12')}
                                >
                                    E-Resource Center
                                </button>
                            </li>
                            <li className="nav-item">
                                <button
                                 className={`nav-link ${activeTab === 'signup_form13' ? 'active' : ''}`}
                                 onClick={() => handleTabClick('signup_form13')}
                                >
                                    Automation of Library
                                </button>
                            </li>
                            <li className="nav-item">
                                <button
                                 className={`nav-link ${activeTab === 'signup_form14' ? 'active' : ''}`}
                                 onClick={() => handleTabClick('signup_form14')}
                                >
                                    Future plan
                                </button>
                            </li>
                        </ul>
                        <div className="tab-content" id="myTabContent">
                            <div
                                className={`tab-pane fade ${activeTab === 'signup_form' ? 'show active' : ''}`} id="signup_form"
                            >
                                <p>
                                    The mission of the library is to support fully the research and
                                    educational endeavors of the students, Research Scholars and faculty
                                    of this university and its affiliated colleges, by collecting,
                                    organizing, preserving, and disseminating information in any form,
                                    by providing effective service and instructional programs, and by
                                    utilizing electronic information systems to provide access to new
                                    information products and services
                                </p>
                            </div>
                            <div
                                className={`tab-pane fade ${activeTab === 'signup_form1' ? 'show active' : ''}`} id="signup_form1"
                            >
                                <p>
                                    University library membership is open to the faculty members,
                                    students and research scholars of the university campus as well as
                                    to the faculty members of the affiliated colleges of the university.
                                    Besides these members, the library also serves to the consultant
                                    members coming from the different educational Institution and
                                    Industrial establishments.
                                </p>
                                <p>
                                    The following table gives a total number of various types of Library
                                    members:
                                </p>
                                <div style={{ overflow: "scroll" }}>
                                    <table className="table table-bordered">
                                        <thead>
                                            <tr>
                                                <th>Library membership during the last two Years</th>
                                                <th>2020-2021</th>
                                                <th>2021-2022</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>Faculty Members including Colleges</td>
                                                <td>18</td>
                                                <td>18</td>
                                            </tr>
                                            <tr>
                                                <td>P.G student</td>
                                                <td>758</td>
                                                <td>925</td>
                                            </tr>
                                            <tr>
                                                <td>Non-Teaching Staff</td>
                                                <td>13</td>
                                                <td>17</td>
                                            </tr>
                                            <tr>
                                                <td>Consultant Member</td>
                                                <td>564</td>
                                                <td>865</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div
                                className={`tab-pane fade ${activeTab === 'signup_form2' ? 'show active' : ''}`} id="signup_form2"
                            >
                                <p>
                                    In the matter of acquisition of books our policy has been to acquire
                                    books of immediate relevance and books useful for advance level
                                    research in the subject concerned. Our aim has been to build up a
                                    rounded collection of books to meet the teaching and research
                                    requirements.
                                </p>
                                <p>
                                    Besides acquisition against payment, the library also received great
                                    books from Central and State Government International organization
                                    and individuals
                                </p>
                                <p>
                                    The following table gives a total number of various types of reading
                                    materials available in the library up to 31.03.2015:
                                </p>
                                <div style={{ overflow: "scroll" }}>
                                    <table className="table table-bordered">
                                        <tbody>
                                            <tr>
                                                <th>Learning Resources</th>
                                                <th>Total Number</th>
                                            </tr>
                                        </tbody>
                                        <tbody>
                                            <tr>
                                                <td colSpan={2}>
                                                    <strong>PRINT RESOURCES</strong>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Total Print Books</td>
                                                <td>185000</td>
                                            </tr>
                                            <tr>
                                                <td>Total Titles</td>
                                                <td>127125</td>
                                            </tr>
                                            <tr>
                                                <td>Ph.D. Theses</td>
                                                <td>16650</td>
                                            </tr>
                                            <tr>
                                                <td>Magazines</td>
                                                <td>42</td>
                                            </tr>
                                            <tr>
                                                <td>Newspaper</td>
                                                <td>17</td>
                                            </tr>
                                            <tr>
                                                <td>Bound Volume of Journals</td>
                                                <td>36800</td>
                                            </tr>
                                            <tr>
                                                <td>Bound Volume of Print Newspaper</td>
                                                <td>Since 1973</td>
                                            </tr>
                                            <tr>
                                                <td colSpan={2}>
                                                    <strong>E-RESOURCES</strong>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>E-Books</td>
                                                <td>12230</td>
                                            </tr>
                                            <tr>
                                                <td>E-Journals</td>
                                                <td>332</td>
                                            </tr>
                                            <tr>
                                                <td>E-Journals through ONOS</td>
                                                <td>14000</td>
                                            </tr>
                                            <tr>
                                                <td>E-Ph.D. Theses on Shodhganga</td>
                                                <td>6113</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div
                                className={`tab-pane fade ${activeTab === 'signup_form3' ? 'show active' : ''}`} id="signup_form3"
                            >
                                <p>
                                    Periodicals are an important source of research and advance
                                    teaching. The library has subscribed to more than 300 periodicals,
                                    30 magazines and 17 Newspapers.
                                </p>
                            </div>
                            <div
                                className={`tab-pane fade ${activeTab === 'signup_form4' ? 'show active' : ''}`} id="signup_form4"
                            >
                                <p>
                                    The library has one reprography unit. The library provides this
                                    facility to all teaching member and research scholar in the
                                    university at nominal cost of 0.40 paisa per copy. This facility has
                                    proved a boon to the scholars. The number of document Xeroxed has
                                    been as under in the current year.
                                </p>
                                <p>
                                    Total number of pages during the year 2015-2016 : 307837 Readers
                                    services in the form of issuing books location of reading material,
                                    Inter-library loan, Initiation of freshers, assistance in the use of
                                    reference tools and catalogue have been an important part of readers
                                    services.
                                </p>
                            </div>
                            <div className={`tab-pane fade ${activeTab === 'signup_form5' ? 'show active' : ''}`} id="signup_form5"
                            >
                                <p>
                                    The library remains open throughout the year except all National
                                    holidays as prescribed in the Rules. It observes working from 8 A.M.
                                    to 12 in the Night on all working days and from 8 A.M to 8 P.M on
                                    holidays. The study room of the library remains open from 8 A.M to 4
                                    P.M. on all working days except National holidays. Some of the
                                    important services provided by the library are :
                                </p>
                                <ul>
                                    <li>Reference Service</li>
                                    <li>Circulation Service</li>
                                    <li>Reprographic Service</li>
                                    <li>Loan to Departmental Libraries</li>
                                    <li>Internet Service</li>
                                    <li>Online access to e-journals</li>
                                </ul>
                            </div>
                            <div
                                className={`tab-pane fade ${activeTab === 'signup_form6' ? 'show active' : ''}`} id="signup_form6"
                            >
                                <ul>
                                    <li>
                                        Central Library is the member of INFLIBNET Programme, so all
                                        members of the library are able to access the services offered by
                                        INFLIBNET.
                                    </li>
                                    <li>Central library is also the Institutional member of DELNET.</li>
                                    <li>Greenstone Digital Library</li>
                                </ul>
                            </div>
                            <div
                                className={`tab-pane fade ${activeTab === 'signup_form7' ? 'show active' : ''}`} id="signup_form7"
                            >
                                <div style={{ overflow: "scroll" }}>
                                    <table className="table table-bordered">
                                        <tbody>
                                            <tr>
                                                <td>Number of Computers</td>
                                                <td>100</td>
                                            </tr>
                                            <tr>
                                                <td>LENOVO</td>
                                                <td>P4</td>
                                            </tr>
                                            <tr>
                                                <td>Servers</td>
                                                <td>04</td>
                                            </tr>
                                            <tr>
                                                <td>UPS(5kv)</td>
                                                <td>07</td>
                                            </tr>
                                            <tr>
                                                <td>UPS (Single user)</td>
                                                <td>10</td>
                                            </tr>
                                            <tr>
                                                <td>Printers Laser</td>
                                                <td>04</td>
                                            </tr>
                                            <tr>
                                                <td>LCD</td>
                                                <td>02</td>
                                            </tr>
                                            <tr>
                                                <td>Vacuum Cleaner</td>
                                                <td>02</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div
                                className={`tab-pane fade ${activeTab === 'signup_form8' ? 'show active' : ''}`} id="signup_form8"
                            >
                                <p>
                                    U.G.C development grant and university budget allocation to the
                                    Library are the two main sources of library finance. U.G.C
                                    development grants are available for purchase of books and back runs
                                    of Journals and equipment. These grant vary from year to year and
                                    there has always has been a gap period. On the other Hand University
                                    budget allocations are assured sources of library finance.
                                </p>
                            </div>
                            <div
                                className={`tab-pane fade ${activeTab === 'signup_form9' ? 'show active' : ''}`} id="signup_form9"
                            >
                                <div className="down">
                                    <div className="boxing">
                                        <div className="left">
                                            <img src="../assets/images/staff/staff-pic-1.jpg" alt="" />
                                        </div>
                                        <div className="right">
                                            <h1>Prof. J.A. Siddiqui</h1>
                                            <p>University Librarian (officiating)</p>
                                            <span>B.Sc,(Hons), M.Sc., M.Lib.Sc., M.Phil., Ph.D.(Alig)</span>
                                            <div className="mt-2">
                                                <a
                                                    href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/cv/pdf/J.%20A.%20Siddiqui%20CV%20(1).pdf"
                                                    className="pdf-link"
                                                    target="_blank"
                                                    rel="noreferrer"
                                                >
                                                    View resume
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="boxing">
                                        <div className="left">
                                            <img src="../assets/images/staff/staff-pic-2.jpg" alt="" />
                                        </div>
                                        <div className="right">
                                            <h1>Mr. Anmol Ratan Mishra</h1>
                                            <p>M.A., M.Com., M.Lib.Sc.</p>
                                            <span>Incharge- Acquisition Section</span>
                                            <span>Mobile : 9837734896</span>
                                        </div>
                                    </div>
                                    <div className="boxing">
                                        <div className="left">
                                            <img src="../assets/images/staff/staff-pic-3.jpg" alt="" />
                                        </div>
                                        <div className="right">
                                            <h1>Mr. Krishna Kumar</h1>
                                            <p>M.Sc., M.Lib.Sc., NET</p>
                                            <span>Mobile : Incharge – E-Resource Centre</span>
                                            <span>Mobile : 9412637986</span>
                                        </div>
                                    </div>
                                    <div className="boxing">
                                        <div className="left">
                                            <img src="../assets/images/staff/staff-pic-4.jpg" alt="" />
                                        </div>
                                        <div className="right">
                                            <h1>Mr. Babu Ram</h1>
                                            <p>B. A., M.Lib.Sc., M.Phil.</p>
                                            <span>Incharge- Periodical Section</span>
                                            <span>Mobile : 9411262746</span>
                                        </div>
                                    </div>
                                    <div className="boxing">
                                        <div className="left">
                                            <img src="../assets/images/staff/staff-pic-5.jpg" alt="" />
                                        </div>
                                        <div className="right">
                                            <h1>Ms. Suman Lata</h1>
                                            <p>M.A., M.Lib.Sc.</p>
                                            <span>Incharge – Circulation Section</span>
                                        </div>
                                    </div>
                                    <div className="boxing">
                                        <div className="left">
                                            <img src="../assets/images/staff/staff-pic-6.jpg" alt="" />
                                        </div>
                                        <div className="right">
                                            <h1>Dr. Subhash Chandra</h1>
                                            <p>M.A., M.Ed., M.Lib.Sc., Ph.D.</p>
                                            <span>Incharge - Research Section</span>
                                            <span>Mobile : 9410886464</span>
                                        </div>
                                    </div>
                                    <div className="boxing">
                                        <div className="left">
                                            <img src="../assets/images/staff/staff-pic-7.jpg" alt="" />
                                        </div>
                                        <div className="right">
                                            <h1>Mr. Manoj Kumar</h1>
                                            <p>M.A., B.Ed., B.Lib.Sc</p>
                                            <span>Incharge - Science Section</span>
                                            <span>Mobile : 9412784878</span>
                                        </div>
                                    </div>
                                    <div className="boxing">
                                        <div className="left">
                                            <img src="../assets/images/staff/staff-pic-8.jpg" alt="" />
                                        </div>
                                        <div className="right">
                                            <h1>Ms. Vijay Laxmi Bhardwaj</h1>
                                            <p>M.A., M.Lib.Sc., M.Phil.</p>
                                            <span>Incharge - Digital Library</span>
                                            <span>Mobile : 9997734303</span>
                                        </div>
                                    </div>
                                    <div className="boxing">
                                        <div className="left">
                                            <img src="../assets/images/staff/staff-pic-9.jpg" alt="" />
                                        </div>
                                        <div className="right">
                                            <h1>Mr. Prem Nath Shukla</h1>
                                            <p>B.A., M.Lib.Sc.</p>
                                            <span>Library Clerk</span>
                                            <span>Mobile : 9410232618</span>
                                        </div>
                                    </div>
                                    <div className="boxing">
                                        <div className="left">
                                            <img src="../assets/images/staff/staff-pic-10.jpg" alt="" />
                                        </div>
                                        <div className="right">
                                            <h1>Mr. Pramod Kumar</h1>
                                            <p>B.A.</p>
                                            <span>Janitor</span>
                                        </div>
                                    </div>
                                    <div className="boxing">
                                        <div className="left">
                                            <img src="../assets/images/staff/staff-pic-11.jpg" alt="" />
                                        </div>
                                        <div className="right">
                                            <h1>Mr. Ravindra Kumar</h1>
                                            <p>Intermediate</p>
                                            <span>Book Lifter</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div
                                className={`tab-pane fade ${activeTab === 'signup_form10' ? 'show active' : ''}`} id="signup_form10"
                            >
                                <div className="global-card-parent">
                                    <div className="col-md-4 mb-4 global-card">
                                        <a
                                            href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/pdf-files/Plagiarism-Policy_n.pdf"
                                            target="_blank"
                                            className="text-dark"
                                            rel="noreferrer"
                                        >
                                            <i className="fas fa-file-pdf fa-3x pdf-icon" />
                                            <p>Click to View</p>
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div
                                className={`tab-pane fade ${activeTab === 'signup_form11' ? 'show active' : ''}`} id="signup_form11"
                            >
                                <div className="row global-card-parent">
                                    <div className="col-md-2 mb-4 global-card">
                                        <a
                                            href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/pdf-files/Library-Policy_n.pdf"
                                            target="_blank"
                                            className="text-dark"
                                            rel="noreferrer"
                                        >
                                            <i className="fas fa-file-pdf fa-3x pdf-icon" />
                                            <p>
                                                Library Policy
                                                <br />
                                                Click to View
                                            </p>
                                        </a>
                                    </div>
                                    <div className="col-md-2 mb-4 global-card">
                                        <a
                                            href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/pdf-files/Library-Rules_n.pdf"
                                            target="_blank"
                                            className="text-dark"
                                            rel="noreferrer"
                                        >
                                            <i className="fas fa-file-pdf fa-3x pdf-icon" />
                                            <p>
                                                Library Rules
                                                <br />
                                                Click to View
                                            </p>
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div
                                className={`tab-pane fade ${activeTab === 'signup_form12' ? 'show active' : ''}`} id="signup_form12"
                            >
                                <p>
                                    The UGC-Infonet E-journal consortium is our pride in the field of
                                    education and research which has been formally launched on the
                                    concluding day of UGC's Golden Jubilee celebrations by his
                                    Excellency the President of India, Dr. APJ Abdul Kalam at Vigyan
                                    Bhawan on 28th December 2003 by dedicating a bouquet of e-journals
                                    to the nation.
                                </p>
                                <p>
                                    With globalization of education and competitive research the demand
                                    for the journals has increased over the years. Due to scarcity of
                                    funds, libraries have been forced to discontinue the scholarly
                                    journals, which have great impact to the users. In order to provide
                                    the current literature to academia, UGC has initiated the UGC
                                    INFONET E-Journal consortium. Timely initiative of UGC is a great
                                    boon to academia, in the country, which enables them to access large
                                    number of scholarly journals from reputed publishers, aggregators
                                    and society publications. Under the consortium, about 5000 full text
                                    scholarly electronic journals from 25 publishers across the globe
                                    can be accessed. The consortium provides current as well as archival
                                    access to core and pee-reviewed journals in different disciplines.
                                    The whole programme has been implemented in different phases.
                                </p>
                                <p>
                                    CCS University, which comes under the purview of UGC, has been
                                    provided access to these journals and it will gradually be extended
                                    to affiliated colleges as well. It covers almost all areas of
                                    learning like Arts, Humanities, Social Sciences, Physical Sciences
                                    and Chemical Sciences, Life Sciences, Computer Sciences, Mathematics
                                    and Statistics etc. and other subject areas are to be added in near
                                    future. The programme is wholly funded by the UGC and monitored by
                                    INFLIBNET ( Information and Library Network ) Centre, Ahmedabad.
                                    Very recently the internet lab is converted into E-Resource centre
                                    with the additional provision of access to e-books, e-journals and
                                    institutional repository. The centre is equipped with 50 latest
                                    computers with internet facility.
                                </p>
                            </div>
                            <div
                                className={`tab-pane fade ${activeTab === 'signup_form13' ? 'show active' : ''}`} id="signup_form13"
                            >
                                <p>
                                    The project of computerization of Central library has been taken as
                                    the priority of the library. SOUL 2.0 Library software developed by
                                    UGC INFLIBNET has been installed for the automation of the library.
                                    20 computers have already been installed in the various sections of
                                    the library and all are on LAN. Two UPS of 5 KV, Camera, One server
                                    and an LCD are some of the other equipments available in library.
                                    More than one lac of documents are entered and the OPAC is provided
                                    to locate the documents in the library. Soon the library will be
                                    totally automated using Bar Code Technology in its lending
                                    operations.
                                </p>
                                <p>PROGRAMMES ORGANISED BY LIBRARY</p>
                                <p></p>
                                <ul>
                                    <li>
                                        E-Resources orientation programme for Faculty Members and Research
                                        Scholars
                                    </li>
                                    <li>
                                        Training to Library Staff members was given by the INFLIBNET Team
                                        for the automation of Central Library using SOUL Software
                                    </li>
                                    <li>
                                        Three days Book Exhibition was organized during 16-18 December
                                        2009 at the University Community Centre, in which more than 50
                                        publishers from all parts of the country participated.
                                    </li>
                                    <li>
                                        Three days Book Exhibition was organized during 21-23 December
                                        2012 at the University Auditorium Lawn, in which more than 40
                                        publishers from all parts of the country participated.
                                    </li>
                                    <li>
                                        Three days Book Exhibition was organized during 21-23 December
                                        2011 at the University Auditorium, in which about 55 publishers
                                        from all parts of the country participated.
                                    </li>
                                    <li>
                                        One Day Workshop on "Use of Information Technology in Library:
                                        Challenges and Opportunities" in the Department of Computer
                                        Science, Ginni Devi Girls (PG) College, Modinagar, Ghaziabad on
                                        09.01.2015.
                                    </li>
                                    <li>
                                        One Day Workshop on "User Awareness Programme for Information
                                        Searching" in the Department of Botany, R.G. (PG) College, Meerut
                                        on 11.03.2015.
                                    </li>
                                </ul>
                            </div>
                            <div
                                className={`tab-pane fade ${activeTab === 'signup_form14' ? 'show active' : ''}`} id="signup_form14"
                            >
                                <ul>
                                    <li>Digitization of Documents</li>
                                    <li>Online access to Databases</li>
                                    <li>Microfilming of Newspapers</li>
                                    <li>Development of Library Website</li>
                                    <li>Access to National and International Library Networks</li>
                                    <li>RFID Technology application for document security</li>
                                </ul>
                            </div>
                            {/* <div className="tab-pane fade" id="signup_form" role="tabpanel" aria-labelledby="signup">
	                            <div className="fancyformcontainer">
	                            	<h3 className="text-center">Sign Up</h3>
									<form>
									    <div className="form-group mt-4">
									        <label for="email_id">Email address</label>
									        <input type="email" className="form-control" id="email_id" placeholder="Enter valid email address">
									    </div>
									    <div className="form-group mt-4">
									        <label for="password">Password</label>
									        <input type="password" className="form-control" id="password" placeholder="Please provide password">
									    </div>
									    <div className="form-group mt-4">
									        <label for="password">Confirm Password</label>
									        <input type="password" className="form-control" id="confirm password" placeholder="Please retype password and try agaib">
									    </div>
									    <div className="text-center">
					    					<button type="submit" className="btn formsubmitbtn">Submit</button>
					    				</div>
				  					</form>
				 				</div>
	                        </div> */}
                            {/* </div> */}
                            {/* 	</div> */}
                        </div>
                    </div>
                </div>
            </div>

        </div>
    )
}

export default Main;